import React, { useState } from 'react';
import { X } from 'lucide-react';
import { redButton } from '../PageShell';

const qtyBtn = { width: '30px', height: '30px', border: '1px solid rgba(201,168,76,0.4)', color: '#C9A84C', background: 'transparent', fontSize: '18px', lineHeight: 1, cursor: 'pointer' };

export const CustomizeModal = ({ item, onAdd, onClose }) => {
  const [modSel, setModSel] = useState([]);
  const [modQty, setModQty] = useState(1);
  const maxMods = item?.max_modifiers || 6;

  const toggleMod = (id) => {
    setModSel((prev) => {
      if (prev.includes(id)) return prev.filter((x) => x !== id);
      if (prev.length >= maxMods) return prev;
      return [...prev, id];
    });
  };

  const unit = item.price + modSel.reduce((s, id) => {
    const m = item.modifiers.find((x) => x.id === id);
    return s + (m ? m.price : 0);
  }, 0);

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4" style={{ background: 'rgba(10,10,10,0.9)', backdropFilter: 'blur(8px)' }} data-testid="customize-modal">
      <div className="w-full max-w-md max-h-[88vh] overflow-y-auto" style={{ background: '#141414', border: '1px solid rgba(201,168,76,0.25)' }}>
        <div className="p-6">
          <div className="flex justify-between items-start">
            <h3 className="font-display" style={{ fontSize: '24px', fontWeight: 700, color: '#F5F5F0' }}>{item.name.es}</h3>
            <button onClick={onClose} className="text-[#C2C1B6] hover:text-[#C9A84C]" data-testid="customize-close"><X className="w-6 h-6" /></button>
          </div>
          <p className="font-body mt-1" style={{ fontSize: '13px', fontWeight: 300, color: '#C2C1B6', lineHeight: 1.6 }}>{item.description.es}</p>
          <div className="flex items-center justify-between mt-6">
            <span className="font-body uppercase" style={{ fontSize: '11px', letterSpacing: '2px', color: '#C9A84C', fontWeight: 600 }}>Modificaciones</span>
            <span className="font-body" style={{ fontSize: '11px', color: '#7FB77E', background: 'rgba(127,183,126,0.12)', padding: '3px 10px', borderRadius: '999px' }}>Hasta {maxMods}</span>
          </div>
          <div className="mt-3">
            {item.modifiers.map((m) => {
              const checked = modSel.includes(m.id);
              return (
                <label key={m.id} className="flex items-center justify-between py-3 cursor-pointer" style={{ borderBottom: '1px solid rgba(201,168,76,0.12)' }} data-testid={`mod-${m.id}`}>
                  <span className="flex items-center gap-3">
                    <input type="checkbox" checked={checked} onChange={() => toggleMod(m.id)} style={{ accentColor: '#C9A84C', width: '16px', height: '16px' }} />
                    <span className="font-body" style={{ fontSize: '14px', color: checked ? '#F5F5F0' : '#C2C1B6' }}>{m.name.es}</span>
                  </span>
                  <span className="font-body" style={{ fontSize: '13px', color: m.price > 0 ? '#C9A84C' : '#C2C1B6' }}>+${m.price.toFixed(2)}</span>
                </label>
              );
            })}
          </div>
          <div className="flex items-center gap-4 mt-5">
            <button onClick={() => setModQty((q) => Math.max(1, q - 1))} style={qtyBtn} data-testid="modal-minus">−</button>
            <span className="font-bebas" style={{ fontSize: '20px', minWidth: '24px', textAlign: 'center' }} data-testid="modal-qty">{modQty}</span>
            <button onClick={() => setModQty((q) => Math.min(20, q + 1))} style={qtyBtn} data-testid="modal-plus">+</button>
          </div>
          <button onClick={() => onAdd(item, modSel, modQty)} style={{ ...redButton, width: '100%', marginTop: '20px' }} data-testid="modal-add-btn">
            Agregar · ${(unit * modQty).toFixed(2)}
          </button>
        </div>
      </div>
    </div>
  );
};
